export const ASSIGNMENT_COMPOSITION_RETURN_SCHEMA = "assignment_composition_return.v1";
export const ASSIGNMENT_COMPOSITION_RETURN_PREFIX = "allvoiced.assignment-composition-return.v1:";

const FIELD_KEYS = Object.freeze([
  "title",
  "description",
  "assigneeEmails",
  "instructions",
  "availableFrom",
  "dueAt",
  "closesAt",
]);

function storageKey(token) {
  return `${ASSIGNMENT_COMPOSITION_RETURN_PREFIX}${token}`;
}

export function generateAssignmentReturnToken(cryptoOwner = window.crypto) {
  if (typeof cryptoOwner?.randomUUID === "function") return cryptoOwner.randomUUID();
  if (typeof cryptoOwner?.getRandomValues !== "function") {
    throw new Error("ASSIGNMENT_RETURN_CRYPTO_UNAVAILABLE");
  }
  const bytes = new Uint8Array(24);
  cryptoOwner.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, "0")).join("");
}

function boundedPayload({ form = {}, selectedActivity = null } = {}) {
  return {
    schema: ASSIGNMENT_COMPOSITION_RETURN_SCHEMA,
    priorActivityId: selectedActivity?.id ? String(selectedActivity.id) : null,
    form: Object.fromEntries(FIELD_KEYS.map(key => [key, typeof form[key] === "string" ? form[key] : ""])),
  };
}

function isValidPayload(value) {
  return Boolean(
    value &&
    value.schema === ASSIGNMENT_COMPOSITION_RETURN_SCHEMA &&
    (value.priorActivityId === null || typeof value.priorActivityId === "string") &&
    value.form &&
    FIELD_KEYS.every(key => typeof value.form[key] === "string")
  );
}

export function saveAssignmentCompositionReturn({ form, selectedActivity, storage = window.sessionStorage, cryptoOwner } = {}) {
  const token = generateAssignmentReturnToken(cryptoOwner);
  storage.setItem(storageKey(token), JSON.stringify(boundedPayload({ form, selectedActivity })));
  return token;
}

export function readAssignmentCompositionReturn(token, storage = window.sessionStorage) {
  if (!token || typeof token !== "string") return { state: "missing", payload: null };
  const key = storageKey(token);
  const raw = storage.getItem(key);
  if (raw === null) return { state: "missing", payload: null };
  try {
    const payload = JSON.parse(raw);
    if (!isValidPayload(payload)) {
      storage.removeItem(key);
      return { state: "invalid", payload: null };
    }
    return { state: "valid", payload };
  } catch {
    storage.removeItem(key);
    return { state: "invalid", payload: null };
  }
}

export function consumeAssignmentCompositionReturn(token, storage = window.sessionStorage) {
  if (token && typeof token === "string") storage.removeItem(storageKey(token));
}

export function activityAuthoringReturnSearch(token) {
  return token ? `?returnToken=${encodeURIComponent(token)}` : "";
}

export const ASSIGNMENT_COMPOSITION_FIELD_KEYS = FIELD_KEYS;
